// Free-tier (tier 0) feature fences, enforced CLIENT-SIDE only.
//
// This map is the single source of truth for what a Free account can do across
// the app. It is applied by PaymentContext over the backend entitlements object
// ONLY when the account is on the Free tier (tier 0, no active trial). Paid tiers
// and trials keep their backend-computed entitlements untouched, so the normal
// tier logic still overrides these defaults.
//
// Two shapes live here:
//   - Count caps:  { enabled: true, limit: N }  → surface shows top-N, rest gated.
//                  PaymentContext carries the live `used` from the backend and
//                  recomputes `left` / `limitReached` against this Free `limit`.
//   - Action locks:{ enabled: false }            → the create/edit/add action is
//                  locked (EntitlementsGuard shows the crown + upsell).
//
// The string keys mirror EntitlementsKeys in src/guards/EntitlementsGuard.jsx.
// They are written as literals here on purpose to avoid a circular import
// (PaymentContext → this map → guard → PaymentContext).
export const FREE_TIER_ENTITLEMENTS = {
    // Integrations: Free can connect up to 5 ad accounts.
    active_ad_accounts: { enabled: true, limit: 5 },

    // Discovery: Free can browse the ad library freely but cannot add advertisers
    // to the watch list. Existing brands_follow guards read this and lock "add".
    brands_follow: { enabled: false, limit: 0 },

    // Creative report: Free sees its top 20 live ads (by spend); the rest are
    // veiled with an upgrade prompt. Reuses the built live-ads blur veil / table
    // cut, just driven at 20 for Free.
    live_ads_analyzed: { enabled: true, limit: 20 },

    // Views: Free keeps the default views it gets on connecting an ad account,
    // but cannot create new views or add widgets.
    views_manage: { enabled: false },

    // Reports: Free keeps its default report(s) but cannot create new ones.
    reports_manage: { enabled: false },

    // Weekly insights: Free sees 1 insight, the rest behind a locked "see more".
    weekly_insights: { enabled: true, limit: 1 },

    // Advertiser view: Free sees a strip of the advertiser's top ads; the rest,
    // the engagement-ads strip, and "View all" are gated.
    advertiser_ads: { enabled: true, limit: 8 },
    advertiser_view_all: { enabled: false },

    // Per-creative view: Free sees 1 insight and 1 idea, no comments, and tags
    // it cannot configure.
    creative_insights: { enabled: true, limit: 1 },
    creative_ideas: { enabled: true, limit: 1 },
    creative_comments: { enabled: false },
    tag_config: { enabled: false },
}
